import type { ChangeEvent } from 'react';
import type { UseFormRegisterReturn } from 'react-hook-form';

/** Strips everything but digits: "29.614.532", "29 614 532" and "29-614-532" become "29614532". */
export const onlyDigits = (value: string) => value.replace(/\D/g, '');

/**
 * A registered react-hook-form field that keeps only digits as it is typed or pasted.
 * Mobile keyboards insert the dots of a DNI on their own; with type="number" the browser
 * then rejected "29.614532" before our validation ran, so DNI fields are text fields
 * with inputMode="numeric" and this cleans what lands in them.
 */
export const registerOnlyDigits = <TName extends string>(field: UseFormRegisterReturn<TName>) => ({
  ...field,
  onChange: (event: ChangeEvent<HTMLInputElement>) => {
    const digits = onlyDigits(event.target.value);
    // Only rewrite when something was removed, so the caret stays put on normal typing.
    if (digits !== event.target.value) {
      event.target.value = digits;
    }
    return field.onChange(event);
  },
});
